import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_BASE_URL, ResolutionAndMitigationPlanDto } from '@fdm/api-client';
import { Observable } from 'rxjs';

@Injectable()
export class ResolutionAndMitigationApiService {
  private _http = inject(HttpClient);

  private _baseUrl = inject(API_BASE_URL);

  private _url = this._baseUrl + '/api/ResolutionAndMitigationPlan';

  public save(body: ResolutionAndMitigationPlanDto): Observable<number> {
    return this._http.post<number>(this._url, body);
  }

  public update(body: ResolutionAndMitigationPlanDto): Observable<number> {
    return this._http.put<number>(this._url, body);
  }
}
